export const getStorage = () => sessionStorage;

const scrollWithRetry = (targetY: number, retriesLeft: number) => {
  const maxScrollY = document.documentElement.scrollHeight;
  if (targetY > maxScrollY && retriesLeft > 0) {
    setTimeout(() => {
      scrollWithRetry(targetY, retriesLeft - 1);
    }, 200);
  } else {
    window.scrollTo(0, targetY);
  }
};

export const deleteScrollPos = (asPath: string) => {
  try {
    getStorage().removeItem(`scrollPos:${asPath}`);
    // eslint-disable-next-line no-empty
  } catch (error) {}
};

export const saveScrollPos = (asPath: string) => {
  try {
    getStorage().setItem(
      `scrollPos:${asPath}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
        windowHeight: document.documentElement.scrollHeight,
      })
    );
    // eslint-disable-next-line no-empty
  } catch (error) {}
};

export const restoreScrollPos = (asPath: string, bfcache?: boolean) => {
  const navigation = window.performance?.getEntriesByType('navigation') as any;
  try {
    if (
      (navigation?.length &&
        navigation?.[0]?.type &&
        navigation?.[0]?.type === 'back_forward') ||
      bfcache
    ) {
      const json = getStorage().getItem(`scrollPos:${asPath}`);
      deleteScrollPos(asPath);
      const scrollPos = json ? JSON.parse(json) : undefined;
      if (scrollPos && scrollPos.y > -1) {
        // 저장된 windowHeight를 사용하여 HTML에 min-height 설정
        // if (scrollPos.windowHeight) {
        //   document.documentElement.style.minHeight = `${scrollPos.windowHeight}px`;
        // }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const y = Number(scrollPos.y) || 0;
        // minHeight 설정이 DOM에 반영된 후 스크롤 이동
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollWithRetry(y, 5);
          });
        });
        // setTimeout(() => {
        //   // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        //   window.scrollTo(window.screenY, scrollPos.y || 0);
        //   // getStorage().removeItem(`scrollPos:${asPath}`);
        // }, 0);
      }
      return;
      // eslint-disable-next-line no-empty
    }
    if (window?.performance?.navigation?.type === 2 || bfcache) {
      const json = getStorage().getItem(`scrollPos:${asPath}`);
      deleteScrollPos(asPath);
      const scrollPos = json ? JSON.parse(json) : undefined;
      if (scrollPos && scrollPos.y > -1) {
        // 저장된 windowHeight를 사용하여 HTML에 min-height 설정
        // if (scrollPos.windowHeight) {
        //   document.documentElement.style.minHeight = `${scrollPos.windowHeight}px`;
        // }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const y = Number(scrollPos.y) || 0;
        // minHeight 설정이 DOM에 반영된 후 스크롤 이동
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollWithRetry(y, 5);
          });
        });
        // setTimeout(() => {
        //   // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        //   window.scrollTo(window.screenY, scrollPos.y || 0);
        //   // getStorage().removeItem(`scrollPos:${asPath}`);
        // }, 0);
      }
    }
  } catch (e) {
    console.error(e);
  }
};
